export const UPDATE_CARE_PROVIDER_REQUEST = 'UPDATE_CARE_PROVIDER_REQUEST';

export const updateCareProviderRequest = ( id, updateData ) => ({
    type: UPDATE_CARE_PROVIDER_REQUEST,
    payload: { id, updateData }
});
